module.exports = require("graphql-codegen-plugin-helpers");